module.exports = __webpack_public_path__ + "static/media/website1.de3fd26a.jpg";